module.exports = __webpack_public_path__ + "static/media/step5_gif.c418fa2e.gif";